import { Pipe, PipeTransform } from '@angular/core';
import { ShipmentItemState } from '@app/shared/enums/ShipmentItemState.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'shipmentItemState',
    standalone: false
})
export class ShipmentItemStatePipe implements PipeTransform {
  public itemStates = ShipmentItemState;
  public shipmentItemsList: any[] = [];

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(ShipmentItemState).find(
          k => ShipmentItemState[k as keyof typeof ShipmentItemState] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.shipmentItemsList = [];

    for (const [propertyKey, propertyValue] of Object.entries(ShipmentItemState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.shipmentItemsList.push({ id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) });
    }

    return this.shipmentItemsList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ShipmentItemState)) {
      if (propertyValue == Id) {
        return { id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ShipmentItemState)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
